'use es6';

import { QUERY_PARAM_TERM_UPDATED } from 'pricing-pages-unified-ui/constants/ActionTypes';
export const updateQueryParamTerm = payload => ({
  type: QUERY_PARAM_TERM_UPDATED,
  payload
});